import { Constants } from '@pwc/pwc-deals-web-common';
import _find from 'lodash/find';
import { structuredAnalysisLinkToDisplay } from '../../../common/engine/utilities/structured-data-utilities';
import {
  isStructuredAnalysis2ContentType,
  viewAnalysisPath,
  viewHypothesisPath,
  viewStructuredAnalysis2PathForSubType,
} from '../../../common/services/urlService';

export const getViewPathForAnalysis = (
  projectId,
  analysis,
  kfa = false,
  isPwcUser = true
) => {
  if (isStructuredAnalysis2ContentType(analysis.type)) {
    return viewStructuredAnalysis2PathForSubType({
      projectId,
      contentThreadId: analysis.contentThreadId,
      isPwcUser,
    });
  }
  const url = structuredAnalysisLinkToDisplay(
    projectId,
    analysis.title,
    analysis.subType
  );
  const isAnalysis = kfa || url === analysis.title;
  const isStructuredAnalysis =
    analysis &&
    analysis.subType &&
    Object.values(Constants.structuredDocumentSubtypeCodes).includes(
      analysis.subType
    );
  const result =
    isAnalysis && !isStructuredAnalysis
      ? viewAnalysisPath(projectId, analysis.contentThreadId)
      : url;
  return result;
};

export const getViewPathForKfa = (projectId, analysis) => {
  const url = structuredAnalysisLinkToDisplay(
    projectId,
    analysis.title,
    analysis.subType
  );

  const result =
    url === analysis.title
      ? viewHypothesisPath(projectId, analysis.contentThreadId)
      : url;
  return result;
};

export const analysisLinkBuilder =
  (analyses, projectId, isPwcUser) => (targetId) => {
    const targetAnalysis = _find(
      analyses,
      (a) => a.contentThreadId === targetId
    );
    return getViewPathForAnalysis(projectId, targetAnalysis, false, isPwcUser);
  };
